export default __webpack_public_path__ + "static/media/m_welcome_bg.2f99c30a.png";